import  api, { globalErrorHandler } from "../Api"

export const GET_GOLDEN_REFERRERS = "GET_GOLDEN_REFERRERS";
export const GR_LOADING = "GR_LOADING";


const config = {
  headers: {
      'content-type': 'application/json',
  }
};

export const GetGoldenReferres = () => {
  
  return async dispatch => {
    dispatch({
      type: GR_LOADING
    });
    await api.get(`/api/Raft/GetGoldenReferresList`,config).then(res => 
      dispatch({
        type: GET_GOLDEN_REFERRERS,
        data: res.data
        })
      ).catch(globalErrorHandler); 
  };
};
